import React, { FC } from 'react';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import MediaAttachments from 'app/components/MediaAttachments';
import { PostComposerFormState } from 'app/modules/posts/modules/post/components/composer/utils/postComposerFormState';
import { Field } from '@kontentino/ui';
import { FileSourceType } from 'app/components/fileSourceInput/hooks/useFileSource';
import { MediaLibraryItemFileType } from 'types/MediaLibrary';
import { UseSetStateAction } from 'utils/hooks/useSetState';
import { useMediaUploadStatus } from 'components/posts/detail/composer/providers/MediaUploadStatusProvider';
import { RunningUpload } from 'types/RunningUpload';
import { PseudoPostTypesUtils } from 'app/modules/posts/utils/pseudoPostType';

type Props = {
  value: PostComposerFormState;
  onChange: UseSetStateAction<PostComposerFormState>;
  maxCount: number;
  allowedFiles: MediaLibraryItemFileType[];
  canSetupVideoThumbnail?: boolean;
  sources?: readonly FileSourceType[];
};

const PostComposerContentMediaAttachments: FC<Props> = ({
  value,
  onChange,
  maxCount,
  allowedFiles,
  canSetupVideoThumbnail,
  sources,
}) => {
  const { setIsUploading } = useMediaUploadStatus();

  const onRunningUploadsChange = (runningUploads: RunningUpload[]) => {
    setIsUploading(runningUploads?.length > 0);
  };

  const pseudoPostTypeOption = PseudoPostTypesUtils.findOptionByCombination({
    type: value.type,
    subtype: value.subtype,
    pageType: value.page.type,
    attachments: value.attachments,
  });

  return (
    <Field.Group>
      <Field.Label required>Media</Field.Label>
      <UserPermissionGate
        scopes={UserPermission.POST_EDIT_ASSETS}
        deniedProps={{ disabled: true }}
      >
        <MediaAttachments
          page={value.page}
          onRunningUploadsChange={onRunningUploadsChange}
          attachments={value.attachments}
          maxCount={maxCount}
          allowedFiles={allowedFiles}
          onAttachmentsChange={(updater) =>
            onChange((prev) => {
              const updated = updater(prev.attachments);
              const attachments = {
                ...prev.attachments,
                ...updated,
              };

              const typeAndSubtype = pseudoPostTypeOption?.getTypeAndSubtype({
                attachments,
              });

              return {
                attachments,
                ...typeAndSubtype,
              };
            })
          }
          canSetupVideoThumbnail={canSetupVideoThumbnail}
          sources={sources}
        />
      </UserPermissionGate>
    </Field.Group>
  );
};
export default PostComposerContentMediaAttachments;
